import styled from 'styled-components';
import { rgba } from 'polished';
import { primary, neutral, white } from '../../../../style/colors';

export const Section = styled.div`
  margin-top: ${props => props.compact ? '30px' : '40px'};
  padding: ${props => props.compact ? '0' : '40px 0'};
  border-top: ${props => props.compact ? 'none' : `2px solid ${neutral[100]}`};
`;

export const SectionTitle = styled.h2`
  font-size: ${props => props.compact ? '18px' : '24px'};
  font-weight: 700;
  color: ${neutral[900]};
  margin-bottom: ${props => props.compact ? '16px' : '24px'};
  letter-spacing: -0.3px;
`;

export const Grid = styled.div`
  display: grid;
  grid-template-columns: ${props =>
    props.compact ? 'repeat(2, 1fr)' : 'repeat(auto-fill, minmax(250px, 1fr))'};
  gap: ${props => props.compact ? '12px' : '20px'};

  @media (max-width: 768px) {
    grid-template-columns: ${props =>
      props.compact ? '1fr' : 'repeat(auto-fill, minmax(200px, 1fr))'};
    gap: ${props => props.compact ? '12px' : '16px'};
  }
`;

export const TyreCard = styled.div`
  background: ${white};
  border: 1px solid ${neutral[200]};
  border-radius: ${props => props.compact ? '8px' : '12px'};
  padding: ${props => props.compact ? '16px' : '20px'};
  cursor: pointer;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  display: flex;
  flex-direction: column;
  position: relative;
  overflow: hidden;

  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    height: 3px;
    background: linear-gradient(90deg, ${primary[500]}, ${primary[400]});
    transform: scaleX(0);
    transform-origin: left;
    transition: transform 0.3s ease;
  }

  &:hover {
    transform: ${props => props.compact ? 'translateY(-2px)' : 'translateY(-4px)'};
    box-shadow: ${props =>
      props.compact
        ? `0 4px 12px ${rgba(primary[500], 0.2)}`
        : `0 8px 24px ${rgba(primary[500], 0.15)}`};
    border-color: ${primary[500]};

    &::before {
      transform: scaleX(1);
    }

    .view-details {
      opacity: 1;
      transform: translateX(0);
    }
  }

  &:active {
    transform: ${props => props.compact ? 'translateY(-1px)' : 'translateY(-2px)'};
  }
`;

export const ImageContainer = styled.div`
  aspect-ratio: 1;
  background: ${neutral[50]};
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 16px;
  overflow: hidden;
`;

export const TyreImage = styled.img`
  max-width: 100%;
  max-height: 100%;
  object-fit: contain;
`;

export const ImagePlaceholder = styled.div`
  color: ${neutral[300]};
  font-size: 48px;

  i {
    font-size: 48px;
  }
`;

export const BrandBadge = styled.div`
  font-size: 10px;
  color: ${white};
  background: linear-gradient(135deg, ${primary[500]} 0%, ${primary[400]} 100%);
  padding: 4px 10px;
  border-radius: 12px;
  text-transform: uppercase;
  font-weight: 600;
  letter-spacing: 0.5px;
  margin-bottom: 8px;
`;

export const TyreName = styled.div`
  font-size: ${props => props.compact ? '14px' : '16px'};
  font-weight: ${props => props.compact ? '600' : '700'};
  color: ${neutral[900]};
  margin-bottom: ${props => props.compact ? '6px' : '8px'};
  line-height: 1.3;
`;

export const TyreSpecs = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  margin-bottom: 12px;
`;

export const SpecLine = styled.div`
  font-size: ${props => props.compact ? '12px' : '13px'};
  color: ${neutral[500]};
  display: flex;
  align-items: center;
  gap: 6px;

  i {
    color: ${primary[500]};
    font-size: ${props => props.compact ? '12px' : '14px'};
  }
`;

export const Description = styled.div`
  font-size: 13px;
  color: ${neutral[400]};
  line-height: 1.5;
  margin-top: auto;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
`;

export const ViewDetailsButton = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  margin-top: 12px;
  padding: ${props => props.compact ? '8px 12px' : '10px 16px'};
  background: linear-gradient(135deg, ${primary[500]} 0%, ${primary[400]} 100%);
  color: ${white};
  border-radius: 6px;
  font-size: ${props => props.compact ? '12px' : '13px'};
  font-weight: 600;
  opacity: ${props => props.compact ? '1' : '0'};
  transform: ${props => props.compact ? 'translateX(0)' : 'translateX(-10px)'};
  transition: all 0.3s ease;

  i {
    font-size: ${props => props.compact ? '14px' : '16px'};
    transition: transform 0.3s ease;
  }

  @media (max-width: 768px) {
    opacity: 1;
    transform: translateX(0);
  }
`;

export const LoadingContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 40px;
  color: ${primary[500]};
  font-size: 15px;
  font-weight: 600;
  background: ${primary[50]};
  border-radius: 12px;
  border: 2px solid ${primary[200]};
  
  i {
    color: ${primary[500]};
    font-size: 20px;
  }
`;

export const EmptyMessage = styled.div`
  text-align: center;
  padding: 40px;
  color: ${neutral[400]};
  font-size: 14px;
`;
